import { http } from 'src/utils/http.util'
import type { TChannelStatusDto, TSubjectType } from 'src/types/communication-channel'

export const AdminCommunicationChannelService = {
  getAvailableChannels: (
    subjectType: TSubjectType,
    subjectId: number,
  ): Promise<TChannelStatusDto[]> =>
    http
      .get('/admin/communication-channels/available', { params: { subjectType, subjectId } })
      .then((res) => res.data),

  assignChannel: (
    communicationChannelId: number,
    subject: { type: TSubjectType; id: number },
  ): Promise<void> =>
    http
      .post('/admin/communication-channels/assign', { communicationChannelId, subject })
      .then((res) => res.data),
}
